import z from "zod";
import { SyncOperation } from "../shared/api.js";
import { Profile } from "../shared/type.app.js";
import { AppStore } from "./store.js";
import { SqlOutbox } from "./sql-outbox.js";
import { getAuthUser } from "./auth0.js";

export const BACKUP_FORMAT = "reading-bee-backup";
export const BACKUP_FORMAT_VERSION = 2;

export const BackupEnvelope = z.object({
  format: z.literal(BACKUP_FORMAT),
  formatVersion: z.literal(BACKUP_FORMAT_VERSION),
  exportedAt: z.string().datetime(),
  accountSubject: z.string().nullable(),
  profiles: z.array(Profile),
  sharedStudents: z.array(z.record(z.string(), z.unknown())),
  pendingOperations: z.array(SyncOperation),
  settings: z.object({
    currentProfileId: z.string().nullable(),
    passcode: z.string().nullable(),
  }),
});
export type BackupEnvelope = z.infer<typeof BackupEnvelope>;

export const createBackup = async (store: AppStore, outbox: SqlOutbox): Promise<BackupEnvelope> => ({
  format: BACKUP_FORMAT,
  formatVersion: BACKUP_FORMAT_VERSION,
  exportedAt: new Date().toISOString(),
  accountSubject: getAuthUser()?.sub ?? null,
  profiles: store.state.profiles,
  sharedStudents: store.state.incomingShares,
  pendingOperations: (await outbox.pending()).map((record) => record.operation),
  settings: {
    currentProfileId: store.state.currentProfileId,
    passcode: store.state.passcode,
  },
});

export const restoreBackup = async (store: AppStore, outbox: SqlOutbox, backup: BackupEnvelope): Promise<void> => {
  await outbox.replaceLocalData(backup.profiles, backup.sharedStudents, backup.settings, backup.pendingOperations);
  store.importState({
    ...store.state,
    profiles: backup.profiles,
    incomingShares: backup.sharedStudents as typeof store.state.incomingShares,
    currentProfileId: backup.settings.currentProfileId,
    passcode: backup.settings.passcode,
  });
};

export const parseBackup = (value: string): BackupEnvelope => BackupEnvelope.parse(JSON.parse(value));
